<template lang="pug">
.container.grid-lg.py-2
  form.list-filters(@submit.prevent="listar")
    .columns.align-center
      .column.col-auto
        .form-group.tooltip.tooltip-bottom(data-tooltip="Tarefa")
          select.form-select(v-model="q.task_eq")
            option(:value="null") Todas tarefas
            option(
              v-for="(label, value) in tasksMap",
              :value="value",
              :key="value"
            ) {{ label }}
      .column.col-auto
        .form-group.tooltip.tooltip-bottom(
          :data-tooltip="'job_output.status' | tModel"
        )
          select.form-select(v-model="q.status_eq")
            option(:value="null") Todos status
            option(
              v-for="(label, value) in jobOutputStatus",
              :value="value",
              :key="value"
            ) {{ label }}
      .column.col-auto.text-right
        button.btn.btn-link.tooltip.tooltip-bottom(
          type="submit",
          :data-tooltip="$i18n.t('views.buttons.filter.label')"
        )
          i.fa.fa-search.fa-lg
  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      .columns
        .column.col-12(v-for="p in list", :key="p.id")
          .my-2
            list-item-card
              .columns(slot="header")
                .column.text-primary.tooltip(data-tooltip="Tarefa") {{ p.task_label }}
                .column.col-auto.tooltip.abbr.mt-1(
                  :data-tooltip="'job_output.created_at' | tModel"
                ) {{ p.created_at | date }}
                .column.col-auto.tooltip(
                  :data-tooltip="'job_output.status' | tModel",
                  :class="{ 'text-error': p.status === 'error', 'text-success': p.status === 'done' }"
                ) {{ p | enums("job_output.status") }}
              div
                .abbr {{ "job_output.output" | tModel }}
                .text-long.my-2ap(v-html="p.output", v-linkified)
              .text-right(slot="footer", v-if="p.permit_retry")
                button.btn(@click="onRetry(p)") Tentar novamente
  .text-center(v-if="pages > 1")
    btn-paginate(
      :page="page",
      :pages="pages",
      :count="count",
      @go-page="goPage",
      @prev-page="prevPage",
      @next-page="nextPage"
    )
</template>

<script>
export default {
  vuex: {
    "sistema/jobOutputs": {
      state: ["list", "status", "count", "page", "pages", "query"],
      getters: ["loading"],
      mutations: ["setQuery", "setPage"],
      actions: ["fetchList", "prevPage", "nextPage", "goPage", "fetchRetry"],
    },
  },
  data() {
    return { q: {} }
  },
  methods: {
    listar() {
      const query = { ...this.q }
      this.setQuery(query)
      this.setPage(1)
      this.fetchList()
    },
    onRetry(jobOutput) {
      const options = {
        cancelLabel: "Não",
        title: "Tem certeza que desja tentar nomamente?",
        okLabel: "Sim",
      }
      this.$dialogs
        .confirm("Ao confirmar vai tentar integrar novamente.", options)
        .then((d) => {
          if (d.ok) {
            this.fetchRetry({ id: jobOutput.id })
              .then(() => {
                this.$toaster.success("Tentar novamente com sucesso.")
                this.listar()
              })
              .catch((e) => {
                this.$toaster.error(e.message)
              })
          }
        })
    },
  },
  computed: {
    jobOutputStatus() {
      return this.$i18n.t("enums.db.enum_job_output_status")
    },
    tasksMap() {
      return {
        "doc-smt-implantar": "Documento: Implantar no Tributário",
        "doc-sei-gerar-paf": "Documento: Gerar PAF no SEI",
        "osm-sei-enviar-documento": "OS-m: Enviar PDF para o SEI",
        "osm-pgd-envia-dados": "OS-m: Enviar dados para o PGD",
        "osm-pgd-envia-status": "OS-m: Enviar status para o PGD",
        "osm-petis-concluir-vistoria": "OS-m: Concluir vistoria no Peits",
      }
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    this.listar()
  },
}
</script>
